export default __webpack_public_path__ + "static/media/appapacho.dc5c40f5.png";